var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalEditionLieuPortage",
      attrs: {
        size: "lg",
        title: "Paramétrage du lieu de portage",
        "no-close-on-backdrop": "",
        scrollable: ""
      }
    },
    [
      _c("template", { slot: "default" }, [
        _vm.lieuEnCours
          ? _c(
              "div",
              { staticClass: "container" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "libelle" + _vm.lieuEnCours.id } },
                        [_vm._v("Libellé")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lieuEnCours.libelle,
                            expression: "lieuEnCours.libelle"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "libelle" + _vm.lieuEnCours.id,
                          type: "text",
                          maxlength: "120"
                        },
                        domProps: { value: _vm.lieuEnCours.libelle },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.lieuEnCours,
                              "libelle",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      !_vm.nomValide
                        ? _c("div", { staticClass: "error" }, [
                            _vm._v("Ce champ est requis")
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _c("div", { staticClass: "col-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Actif")]),
                        _c("ToggleButton", {
                          attrs: {
                            labels: { checked: "Oui", unchecked: "Non" },
                            color: { checked: "#16D39A", unchecked: "#CCCCCC" },
                            height: 30,
                            width: 85
                          },
                          model: {
                            value: _vm.lieuEnCours.actif,
                            callback: function($$v) {
                              _vm.$set(_vm.lieuEnCours, "actif", $$v)
                            },
                            expression: "lieuEnCours.actif"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    { attrs: { for: "adresse1" + _vm.lieuEnCours.id } },
                    [_vm._v("Adresse")]
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.lieuEnCours.adresse1,
                        expression: "lieuEnCours.adresse1"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      id: "adresse1" + _vm.lieuEnCours.id,
                      type: "text",
                      maxlength: "50"
                    },
                    domProps: { value: _vm.lieuEnCours.adresse1 },
                    on: {
                      focus: function($event) {
                        return $event.target.select()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.lieuEnCours,
                          "adresse1",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "adresse2" + _vm.lieuEnCours.id } },
                        [_vm._v("Complément d'adresse 1")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lieuEnCours.adresse2,
                            expression: "lieuEnCours.adresse2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "adresse2" + _vm.lieuEnCours.id,
                          type: "text",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.lieuEnCours.adresse2 },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.lieuEnCours,
                              "adresse2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "col-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "adresse3" + _vm.lieuEnCours.id } },
                        [_vm._v("Complément d'adresse 2")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lieuEnCours.adresse3,
                            expression: "lieuEnCours.adresse3"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "adresse3" + _vm.lieuEnCours.id,
                          type: "text",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.lieuEnCours.adresse3 },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.lieuEnCours,
                              "adresse3",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "codePostal" + _vm.lieuEnCours.id } },
                        [_vm._v("Code postal")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lieuEnCours.codePostal,
                            expression: "lieuEnCours.codePostal"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "codePostal" + _vm.lieuEnCours.id,
                          type: "text"
                        },
                        domProps: { value: _vm.lieuEnCours.codePostal },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.lieuEnCours,
                              "codePostal",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "col-7" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "ville" + _vm.lieuEnCours.id } },
                        [_vm._v("Ville")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lieuEnCours.ville,
                            expression: "lieuEnCours.ville"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "ville" + _vm.lieuEnCours.id,
                          type: "text"
                        },
                        domProps: { value: _vm.lieuEnCours.ville },
                        on: {
                          focus: function($event) {
                            return $event.target.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.lieuEnCours,
                              "ville",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "col-3" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "separation" + _vm.lieuEnCours.id,
                              title:
                                "Sur les bons de livraison, on sépare par régime et texture"
                            }
                          },
                          [_vm._v("Séparation sur BL")]
                        ),
                        _c("ToggleButton", {
                          key: _vm.lieuEnCours.id,
                          attrs: {
                            labels: { checked: "Oui", unchecked: "Non" },
                            color: { checked: "#16D39A", unchecked: "#CCCCCC" },
                            height: 30,
                            width: 85
                          },
                          model: {
                            value: _vm.lieuEnCours.regimesSepares,
                            callback: function($$v) {
                              _vm.$set(_vm.lieuEnCours, "regimesSepares", $$v)
                            },
                            expression: "lieuEnCours.regimesSepares"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "col-10" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Jours d'ouverture")]),
                      _c("div", [
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  1
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(1, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Lundi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  2
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(2, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Mardi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  3
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(3, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Mercredi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  4
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(4, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Jeudi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  5
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(5, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Vendredi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  6
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(6, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Samedi")
                            ])
                          ]
                        ),
                        _c("br"),
                        _c(
                          "label",
                          { staticClass: "label-checkbox-petitelargeur" },
                          [
                            _c("input", {
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: _vm.lieuEnCours.joursOuverture.includes(
                                  0
                                )
                              },
                              on: {
                                change: function($event) {
                                  return _vm.jourChanged(0, $event)
                                }
                              }
                            }),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v("Dimanche")
                            ])
                          ]
                        ),
                        _c("br")
                      ])
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-2" },
                    [
                      _c("BoutonGestionBarquettes", {
                        attrs: {
                          listeBarquetteSelectionnee:
                            _vm.lieuEnCours.barquettes,
                          listeBarquette: _vm.listeBarquettes,
                          dropLeft: true
                        },
                        on: { enregistrer: _vm.enregistrerBarquettesLieu }
                      })
                    ],
                    1
                  )
                ]),
                _vm._l(_vm.effectifsEnCours, function(effectif, iEffectif) {
                  return _c("div", { key: iEffectif }, [
                    _c("div", { staticClass: "card border-secondary" }, [
                      _c(
                        "div",
                        {
                          class:
                            "card-header flex-center-space-between " +
                            (_vm.estDoublon(effectif) ? "bg-danger" : "")
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.afficherTexteAEffectif(effectif)))
                          ]),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: { content: "Supprimer cet effectif" },
                                  expression:
                                    "{ content: 'Supprimer cet effectif'}"
                                }
                              ],
                              staticClass: "btn btn-danger btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.supprimerEffectif(effectif)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash" })]
                          )
                        ]
                      ),
                      _c("div", { staticClass: "card-body" }, [
                        _vm.estDoublon(effectif)
                          ? _c("div", { staticClass: "error pt-2" }, [
                              _vm._v(
                                "Il existe déjà une configuration identique (même structure de menu, même service, même régime et même texture)"
                              )
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-10" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Structure de menu")]),
                                _c(
                                  "b-form-select",
                                  {
                                    attrs: {
                                      options: _vm.structures,
                                      "value-field": "id",
                                      "text-field": "nom"
                                    },
                                    model: {
                                      value: effectif.structureMenuId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          effectif,
                                          "structureMenuId",
                                          $$v
                                        )
                                      },
                                      expression: "effectif.structureMenuId"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "first" }, [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Structure de menu...")]
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            !effectif.structureMenuId
                              ? _c("div", { staticClass: "error" }, [
                                  _vm._v("Ce champ est requis")
                                ])
                              : _vm._e()
                          ]),
                          _c("div", { staticClass: "col-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Plat témoin")]),
                                _c("ToggleButton", {
                                  attrs: {
                                    labels: {
                                      checked: "Oui",
                                      unchecked: "Non"
                                    },
                                    color: {
                                      checked: "#16D39A",
                                      unchecked: "#CCCCCC"
                                    },
                                    height: 30,
                                    width: 85
                                  },
                                  model: {
                                    value: effectif.aPlatTemoin,
                                    callback: function($$v) {
                                      _vm.$set(effectif, "aPlatTemoin", $$v)
                                    },
                                    expression: "effectif.aPlatTemoin"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-2" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Effectif")]),
                                _c("InputNumber", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    typeFiltre: "quantiteEntiere",
                                    title: "Effectif"
                                  },
                                  model: {
                                    value: effectif.effectif,
                                    callback: function($$v) {
                                      _vm.$set(effectif, "effectif", $$v)
                                    },
                                    expression: "effectif.effectif"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "col-8" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Service")]),
                                _c(
                                  "b-form-select",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: {
                                          content:
                                            "Sans sélection manuelle, tous les services sont sélectionnés",
                                          placement: "top"
                                        },
                                        expression:
                                          "{ content: 'Sans sélection manuelle, tous les services sont sélectionnés', placement: 'top' }"
                                      }
                                    ],
                                    attrs: { options: _vm.optionsServices },
                                    model: {
                                      value: effectif.serviceId,
                                      callback: function($$v) {
                                        _vm.$set(effectif, "serviceId", $$v)
                                      },
                                      expression: "effectif.serviceId"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "first" }, [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Service...")]
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-2" },
                            [
                              _c("BoutonGestionBarquettes", {
                                attrs: {
                                  listeBarquetteSelectionnee:
                                    effectif.barquettes,
                                  listeBarquette: _vm.listeBarquettes,
                                  dropLeft: true
                                },
                                on: {
                                  enregistrer: function($event) {
                                    return _vm.enregistrerBarquettesEffectif(
                                      effectif,
                                      $event
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Régime")]),
                                _c(
                                  "b-form-select",
                                  {
                                    staticStyle: { "margin-top": "3px" },
                                    attrs: { options: _vm.optionsRegimes },
                                    model: {
                                      value: effectif.regimeId,
                                      callback: function($$v) {
                                        _vm.$set(effectif, "regimeId", $$v)
                                      },
                                      expression: "effectif.regimeId"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "first" }, [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Régime...")]
                                      )
                                    ])
                                  ],
                                  2
                                ),
                                !effectif.regimeId
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v("Ce champ est requis")
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ]),
                          _c("div", { staticClass: "col-6" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Texture")]),
                                _c(
                                  "b-form-select",
                                  {
                                    staticStyle: { "margin-top": "3px" },
                                    attrs: { options: _vm.optionsTextures },
                                    model: {
                                      value: effectif.textureId,
                                      callback: function($$v) {
                                        _vm.$set(effectif, "textureId", $$v)
                                      },
                                      expression: "effectif.textureId"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "first" }, [
                                      _c(
                                        "option",
                                        {
                                          attrs: { disabled: "" },
                                          domProps: { value: null }
                                        },
                                        [_vm._v("Texture...")]
                                      )
                                    ])
                                  ],
                                  2
                                ),
                                !effectif.textureId
                                  ? _c("div", { staticClass: "error" }, [
                                      _vm._v("Ce champ est requis")
                                    ])
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                }),
                _vm.effectifsEnCours.length === 0
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v(" Il faut indiquer au moins un effectif ")
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e()
      ]),
      _c("template", { slot: "modal-footer" }, [
        _c("div", { staticClass: "flex-center-space-between w-100" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button", disabled: !_vm.lieuValide },
              on: {
                click: function($event) {
                  return _vm.addEffectif(_vm.lieuEnCours)
                }
              }
            },
            [_vm._v("Ajouter un effectif")]
          ),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary mr-2",
                attrs: { type: "button" },
                on: { click: _vm.annulerEdition }
              },
              [_vm._v("Annuler")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: !_vm.lieuValide },
                on: { click: _vm.enregistrerLieu }
              },
              [_vm._v("Enregistrer")]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }